import { Alert, styled } from '@mui/material';

export const AlertMessage = styled(Alert)({
  '& .MuiAlert-message' : {
    width : 'inherit',
  },
});
